import { requestJSON } from '@/lib/api/api';
import type { OrganizationInvitationPreview } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const organizationInvitationKeys = {
  all: ['organization-invitations'] as const,
  preview: (token: string) => [...organizationInvitationKeys.all, token] as const,
};

export function useOrganizationInvitationPreview(token: string, enabled = true) {
  return useQuery({
    queryKey: organizationInvitationKeys.preview(token),
    enabled: enabled && token.length > 0,
    queryFn: () => requestJSON<OrganizationInvitationPreview>(`/invitations/${token}`),
  });
}
